module.exports = __webpack_public_path__ + "038027f3d2a66e5b605ba9467adda67e.svg";